import * as yup from "yup";

const reminderPreferencesSchema = yup.object().shape({
  EmailPreferenceStatusID: yup
    .number()
    .required("Email preference is required"),
  SMSPreferenceStatusID: yup.number().required("SMS preference is required"),
});

export default reminderPreferencesSchema;
